// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3ssb_","resendInfoText":"OnGoingPaymentBox_resendInfoText__1fD82"};